import React, { FunctionComponent } from 'react';
import Translate from 'ui/atoms/translate';
import WithAuthenticatedPage from 'core/auth/components/with-authenticated-page';
import { AppType } from 'core/auth/types';
import Section from 'ui/atoms/section';
import ProductsTable from 'apps/issuer/pages/products/products-table';
import useGoTo from 'hooks/use-go-to';
import { ISSUER_ROUTES } from 'apps/issuer/pages/routes.config';
import Header from 'src/ui/atoms/header';

interface IssuerDetailsProductsProps {
  issuerId: string;
  numberOfProducts?: number;
  setFilterPopupHeight?: (height: number) => void;
}

const IssuerDetailsProducts: FunctionComponent<IssuerDetailsProductsProps> = ({
  issuerId,
  numberOfProducts,
  setFilterPopupHeight,
}) => {
  const goToProductDetails = useGoTo(ISSUER_ROUTES.productDetails);

  if (!numberOfProducts || numberOfProducts === 0) {
    return null;
  }

  return (
    <Section>
      <Header size="small" spacing="medium">
        <Translate name="dashboard.issuerProducts" />
      </Header>
      <ProductsTable
        goToDetails={(productId: string) => goToProductDetails({ productId })}
        defaultLimit={50}
        issuerId={issuerId}
        hasPermission={true}
        setFilterPopupHeight={setFilterPopupHeight}
      />
    </Section>
  );
};

export default WithAuthenticatedPage(IssuerDetailsProducts, AppType.ISSUER);
